<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">
        {{ $t("lang.msg.collection") }}
      </span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActiveCollection" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonAction @action="openCreateModal" color="gray" large>
          {{ $t('lang.msg.add') }}
        </ButtonAction>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openEditModal"
    />
    <TheModal
      :open="isModalOpen"
      @close="isModalOpen = false"
      :title="newItem.idCollection == undefined ? $t('lang.msg.createRecord') : $t('lang.msg.updateRecord')"
    >
      <template #body>
        <form class="pt-3 space-y-4">
          <InputWrapper label="Colección - ES" content="input" block>
            <InputText v-model="newItem.collectionEs" name="Colección - ES" />
          </InputWrapper>
          <InputWrapper label="Colección - EN" content="input" block>
            <InputText v-model="newItem.collectionEn" name="Colección - EN" />
          </InputWrapper>
          <AdminToggleButton v-model="newItem.collectionAction" />
        </form>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItemCol(`api/Collections/Add`, `api/Collections/Update`, true)"
          >{{ newItem.idCollection == undefined ? $t('lang.msg.add') : $t('lang.msg.update') }}</button>
        </span>
      </template>
    </TheModal>
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import TheModal from "@/components/shared/TheModal";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Collections",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable,
    TheModal
  },
  data() {
    return {
      data: [],
      allData: [],
      headers: {
        idCollection: "#",
        collectionEs: "Colección - ES",
        collectionEn: "Colección - EN",
        collectionAction: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
    this.fetchDataCol(`api/Collections/GetCollections`);
  },
  methods:{
    fetchDataCol(url) {
      this.fetchUrl = url;
      this.$axios.get(url).then((response) => {
        this.data = response.data.filter(element=>{
        return element.collectionAction==this.showActive;});
        this.allData = response.data;
      });
    }, addOrEditItemCol(addURL, editUrl, isGet,  callback = null) {
      let url = "";
      let message = "";

      if (this.isEditing) {
        message = "Registro actualizado con éxito";
        url = editUrl;
      } else {
        message = "Registro añadido con éxito";
        url = addURL;

        // Añadir active al añadir por algun motivo del backend. ¯\_(ツ)_/¯
        this.$set(this.newItem, "active", true);
      }

      this.$axios.post(url, this.newItem).then(() => {
        // After the first request has completed successfully...
        // it either calls a callback function or it fetches all the paginatedData
        if (callback) {
          callback();
        } else {
            this.fetchDataCol(this.fetchUrl);
            this.isEditing = false;
        }
        this.openAlert('success', message, null);

        this.isModalOpen = false;
      });
    },
    toggleActiveCollection(){
      this.showActive= !this.showActive
      this.data=this.allData.filter(element=>{
        return element.collectionAction==this.showActive;
      });
    }
  }
};
</script>
